import {
  ShippingOptionsP,
  ShippingOptionsZ,
} from "../../../../../../../../../api/stores/checkout"
import { useFormContext, useWatch } from "react-hook-form"

import { ShippingData } from "../../../types"
import { useCheckout } from "../../../../../../../../../hooks"
import { useEffect } from "react"

type ShippingOptionItem =
  | ShippingOptionsZ["options"][0]
  | ShippingOptionsP["options"][0]

export function useShippingOptions() {
  const { setData, data } = useCheckout()
  const { shippingOptions } = data.meta.requirements
  const { control, setValue, register } = useFormContext<ShippingData>()
  const optionId = useWatch({ control, name: "shippingOption" })

  useEffect(() => {
    if (optionId && shippingOptions.__kind) {
      let option: ShippingOptionItem | undefined
      for (const item of shippingOptions.options) {
        if (item.id === optionId) {
          option = item as ShippingOptionItem
          break
        }
      }

      setData(data => {
        if (option) {
          let serviceType = {}
          let carrierId = {}

          register("shippingPrice")
          register("shippingType")
          register("carrierName")
          register("currency")
          setValue("shippingPrice", `${option.price}`)
          setValue("shippingType", option.shippingType)
          setValue("carrierName", option.carrierName)
          setValue("currency", option.currency)

          if (
            option.shippingType === "P" ||
            option.shippingType === "Z" ||
            option.shippingType === "M"
          ) {
            register("shippingLogisticType")
            register("shippingServiceType")
            setValue("shippingLogisticType", option.logisticType)
            setValue("shippingServiceType", option.serviceType)

            serviceType = { serviceType: option.serviceType }
          }

          if (
            option.shippingType === "P" ||
            option.shippingType === "Z" ||
            option.shippingType === "M"
          ) {
            register("carrierId")
            setValue("carrierId", option.carrierId)

            carrierId = {
              carrierId: option.carrierId,
            }
          }

          return {
            ...data,
            meta: {
              ...data.meta,
              shipping: {
                destination: null,
                receiver: null,
                ...(data.meta.shipping || {}),
                id: option?.id,
                price: option?.price || 0,
                currency: option?.currency,
                trackingExternal: "",
                shippingStatus: "",
                shippingType: option.shippingType,
                carrierName: option.carrierName,
                ...(option.shippingType === "Z" || option.shippingType === "M"
                  ? serviceType
                  : {}),
                ...(option.shippingType === "Z" ||
                option.shippingType === "P" ||
                option.shippingType === "M"
                  ? carrierId
                  : {}),
              },
            },
          }
        }

        return { ...data }
      })
    }
  }, [optionId, shippingOptions, setData, setValue, register])
}
